import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import {
    Container
} from 'reactstrap';
import { COMMON_NS } from '@intelingu/core/constants/base.constants';
import withTranslation from '@intelingu/core/utils/withTranslation';
import {Link} from "react-router-dom";

export interface FooterProps {
    t?;
}

@withTranslation(COMMON_NS)
@observer export class Footer extends Component<FooterProps, any> {

    render() {
        let linkCollection;

        const hse = {
            "aboutUs": 'https://' + DOMAIN_ENV + '/ueber/',
            "impressum": 'https://' + DOMAIN_ENV + '/kontakt/',
            "root": 'https://' + DOMAIN_ENV + '/',
            "datenschutz": 'https://' + DOMAIN_ENV + '/datenschutz/'
        };

        const intelingu = {
            "aboutUs": 'https://' + DOMAIN_ENV + '/uber-uns/',
            "impressum": 'https://' + DOMAIN_ENV + '/impressum-2/',
            "root": 'https://' + DOMAIN_ENV + '/',
            "datenschutz": 'https://' + DOMAIN_ENV + '/datenschutz/'
        };

        if (DOMAIN_ENV === 'hse-methode.com') linkCollection = hse;
        if (DOMAIN_ENV === 'home.intelingu.com') linkCollection = intelingu;

        const { t } = this.props;

        return <footer>
            <Container>
                <div className={'left'}>
                    &nbsp;
                </div>
                <div className={'center'}>
                    <ul className={'nav top'}>
                        <a href={linkCollection.aboutUs} className={'nav-link'}>{ t('footerAbout') }</a>
                        <a href={linkCollection.impressum} className={'nav-link'}>{ t('footerContacts') }</a>
                    </ul>

                    <ul className={'nav bottom'}>
                        <a href={linkCollection.root} className={'nav-link'}>© {PROJECT_NAME_ENV} 2020</a>
                        {/*<Link to={'/subscriptions'} className={'nav-link'}>{ t('headerPricingLink') }</Link>*/}
                        <a href={linkCollection.datenschutz} className={'nav-link'}>{ t('footerTermsAndConditions') }</a>
                        <a href={linkCollection.impressum} className={'nav-link'}>{ t('footerPrivacy') }</a>
                    </ul>
                </div>
                <div className={'right'}>

                </div>
            </Container>
        </footer>
    }

}
